// extracted by mini-css-extract-plugin
module.exports = {"smallIconSize":"2.4rem"};